import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {DepartmentSelectComponent} from './department-select.component';
import {SimpleSelectModule} from '../base-select/simple-select/simple-select.module';

@NgModule({
    imports: [
        PagesSharedModule,
        SimpleSelectModule
    ],
    declarations: [
        DepartmentSelectComponent
    ],
    entryComponents: [],
    exports: [
        DepartmentSelectComponent,
    ]
})
export class DepartmentSelectModule {
}
